<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/P1AcNi/tc-custom/9781614234746.jpg?1688952707130" alt="This image is the cover for the book Murfreesboro in the Civil War, Civil War Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murfreesboro in the Civil War, Civil War Series
      </h1>
      <p class="bookDescription body article font2">
        <p>As the Civil War unfolded, Murfreesboro became hotly contested by Confederate and Union forces. Both sides occupied the town for significant periods, with power changing hands as the fighting raged. Punctuated by events like Nathan Bedford Forrest�s raid on Union forces in July 1862, Jefferson Davis�s visit and the wedding of General John Hunt Morgan and Martha Ready, wartime Murfreesboro saw no shortage of drama. As combat escalated, the bloody Battle of Stones River and the Nashville Campaign brought more destruction. Yet at war�s end, the resilient locals remained and rebuilt their town from the rubble. Authors and Civil War historians Michael Bradley and Shirley Farris Jones track the tumult of the proceedings to recount the compelling story of Murfreesboro during the Civil War.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael R. Bradley, Shirley Farris Jones
      </h2>
      
      <p class="authorDescription body article">Michael R. Bradley earned his PhD from Vanderbilt University and taught U.S. history for thirty-six years at Motlow College in Tullahoma, Tennessee. Now professor emeritus, he remains an active author and speaker. He has written a number of Civil War books, including Forrest�s Fighting Preacher: David Campbell Kelley of Tennessee, also published by The History Press. Dr. Bradley is a life member of the Sons of Confederate Veterans and is the immediate past commander of the Tennessee Division of SCV. He and his wife live in Tullahoma, Tennessee.<br>Shirley Farris Jones is a lifelong resident of Murfreesboro. A graduate of Knox Business College, she is a Civil War historian and community activist, retired from Middle Tennessee State University, where she had been a staff member for more than thirty years. Shirley is a founding member of the Middle Tennessee Civil War Round Table and a former president of the Rutherford County Historical Society, the Rutherford County Chapter of the Association for the Preservation of Tennessee Antiquities, the Friends of Stones River National Battlefield and the Martha Ready Morgan Chapter of the United Daughters of the Confederacy. Shirley has written three other books, including The Un-Civil War in Middle Tennessee, and numerous Civil War�related articles. She and her husband live in Murfreesboro, Tennessee.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d12261d4